import axios from 'axios';
import { KEY_LOCALSTORAGE } from 'src/app/modules/auth/core/_consts';
import { OctResponse } from 'src/app/modules/models/OctResponse';
import { APP_CONFIGURATION_KEYS } from 'src/app/modules/utils/Constant';
import { localStorageItem } from 'src/app/modules/utils/LocalStorage';
import { ServiceTemplateRequest } from './types';

const BASE_URL = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[
	APP_CONFIGURATION_KEYS.INPATIENT_URL
];

export const saveTemplate = async (
	params: ServiceTemplateRequest
): Promise<OctResponse<any>> => {
	const { data } = await axios.post<OctResponse<any>>(`${BASE_URL}/record-template`, params);
	return data;
};

export const getTemplate = async (id: string): Promise<OctResponse<any>> => {
	const { data } = await axios.get<OctResponse<any>>(`${BASE_URL}/record-template/${id}/template`);
	return data;
};

export const deleteTemplate = async (id: string): Promise<OctResponse<any>> => {
	const { data } = await axios.delete<OctResponse<any>>(
		`${BASE_URL}/record-template/${id}`
	);
	return data;
};

export const getTemplates = async (params: any): Promise<any> => {
	const { data } = await axios.get<any>(`${BASE_URL}/record-template/search`, { params });
	return data;
};

export const getRecordHistories = async (params: any): Promise<any> => {
	const { data } = await axios.get<any>(`${BASE_URL}/record-history/search`, { params });
	return data;
};

export const getRecordHistory = async (params: any): Promise<any> => {
	const { data } = await axios.get<any>(`${BASE_URL}/record-history/${params.id}`, { params });
	return data;
};